import React from 'react';
import {darkV4} from '../../theme';
import Typography from '@mui/material/Typography';

function Footer() {
  return (
    <div style={{marginTop: 10, textAlign: 'center', position: 'sticky', bottom: 0, width: '100% !important', height: '100px !important', backgroundColor: darkV4.palette.divider}}>
      <Typography variant="title">© {new Date().getFullYear()} RT EVENT PRODUCTIONS, INC</Typography>
    </div>
  );
}

export default Footer;
